//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';

export class SchoolEventPolicySignUpSettingsUpdateItem extends ItemBase {
    AllowStudentPortalEventSignup?: boolean;
    CreateNotification?: boolean;
    HoursUntilDeadline?: number;
    AdvanceBookingLimitDays?: number;
    EventHoldExpiry?: number;
    StudentPortalSignupMakeupRequired?: boolean;

    constructor(initializer?: Partial<SchoolEventPolicySignUpSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolEventPolicySignUpSettingsUpdateItem";
}
